module.exports = __webpack_public_path__ + "static/wallpaper_design_award_2026-a005e3fda0310e25cff65cf478a27bc9.png";